import { api } from "../lib/api";
import { session } from "../stores/session";

export interface LoginResult {
  totpRequired: boolean;
  preauthToken: string | null;
}

interface LoginResponseBody {
  totp_required: boolean;
  preauth_token: string | null;
}

export async function login(email: string, password: string): Promise<LoginResult> {
  const res = await api.post<LoginResponseBody>("/api/auth/login", { email, password });
  return { totpRequired: res.totp_required, preauthToken: res.preauth_token };
}

export async function verifyTotp(preauthToken: string, code: string): Promise<void> {
  await api.post("/api/auth/totp/verify", { preauth_token: preauthToken, code });
}

export async function logout(): Promise<void> {
  await api.post("/api/auth/logout");
  session.clear();
}

export interface MeResponse {
  id: string;
  email: string;
  csrf_token: string;
  totp_enabled: boolean;
}

/** Populates the session store from the current cookie session, if any. */
export async function fetchMe(): Promise<MeResponse> {
  const me = await api.get<MeResponse>("/api/auth/me");
  session.user.value = { id: me.id, email: me.email };
  session.csrfToken.value = me.csrf_token;
  return me;
}

export interface TotpSetupResponse {
  secret: string;
  provisioning_uri: string;
}

export async function setupTotp(): Promise<TotpSetupResponse> {
  return api.post<TotpSetupResponse>("/api/auth/totp/setup");
}

export async function confirmTotp(code: string): Promise<string[]> {
  const res = await api.post<{ recovery_codes: string[] }>("/api/auth/totp/confirm", { code });
  return res.recovery_codes;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await api.put("/api/auth/password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export async function regenerateRecoveryCodes(password: string, code: string): Promise<string[]> {
  const res = await api.post<{ recovery_codes: string[] }>("/api/auth/totp/recovery-codes", {
    password,
    code,
  });
  return res.recovery_codes;
}
